import { round } from 'lodash'

export function calcularIMC(peso: number, altura: number) {
  const imc = round(peso / (altura / 100) ** 2, 2)
  return altura !== 0 && imc >= 0 ? imc : undefined
}
